// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var PlaceholderIcon = React.forwardRef(function PlaceholderIcon(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "PlaceholderIcon" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M17.5069 3H6.49307C4.47327 3 3 4.55 3 6.675V17.325C3 19.45 4.47327 21 6.49307 21H17.5069C19.5267 21 21 19.45 21 17.325V14.4125H16.901L15.1188 17.65H8.89307L5.76832 12L8.88119 6.35H15.1069L16.8891 9.5875H20.9881V6.675C21 4.55 19.5267 3 17.5069 3Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10.3069 8.93756L8.6198 12.0001L10.3069 15.0626H13.6812L15.3802 12.0001L13.6812 8.93756H10.3069Z", fill: "currentColor" }))));
});
PlaceholderIcon.displayName = 'PlaceholderIcon';
export default PlaceholderIcon;
//# sourceMappingURL=PlaceholderIcon.js.map